import Vue from 'vue'
import App from './App.vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import 'font-awesome/css/font-awesome.min.css'


import store from "./store";
import router from './router'



import messageSocket from './api/messageSocket'
Vue.prototype.$messageSocket = messageSocket



Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
    store,
  router,


}).$mount('#app')
